import $ from "jquery";
import slick from "slick-slider";

Drupal.behaviors.siwertellSlickSlider = {
  attach: function (context) {
    // Slick slideshow
    $(".slideshow").slick({
      autoplay: true,
      infinite: true,
      dots: true,
      arrows: true,
      appendArrows: $('.slideshow__arrow-container'),
      prevArrow: '<button class="slideshow__arrow btn btn-chevron-left"></button>',
      nextArrow: '<button class="slideshow__arrow btn btn-chevron-right"></button>',
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplaySpeed: 4000,
      fade: true,
      cssEase: "linear",
    });
  },
};
